// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Notes_toolbar__3ZyeV","wrapper":"Notes_wrapper__22s6u","editor":"Notes_editor__2h1Sy"};